import { useRef, useState } from 'react'

export const usePaymentComment = (initialComment = '') => {
  const [comment, setComment] = useState(initialComment)
  const [leaveEmpty, setLeaveEmpty] = useState(false)
  const [showError, setShowError] = useState(false)
  const inputRef = useRef(null)
  const valid = leaveEmpty || Boolean(comment.trim())

  const validate = () => {
    setShowError(true)
    if (!valid) inputRef.current?.focus()
    return valid
  }

  return {
    comment,
    setComment,
    leaveEmpty,
    setLeaveEmpty,
    error: showError && !valid,
    inputRef,
    validate,
    valueForRequest: leaveEmpty ? '' : comment.trim(),
  }
}
